import { useMemo } from "react";
import { useLocation } from "react-router";
import { GeneralSettings, Job, JobForList, JobList } from "./Api";

export const useQuery = () =>
{
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

export const addFont = (fontName, fontAsBase64) => {
    if(!fontName) return;
    if(!fontAsBase64) return;

    const fontFamily = `dynamic-font-${fontName}`;
    const fontFace = new FontFace(fontFamily, `url(${fontAsBase64})`)
    if (!document.fonts.has(fontFace)) {
        document.fonts.add(fontFace);
    }
    return fontFamily;
}

export const getLogoUrl = (jobList: JobList, job: Job, settings: GeneralSettings) => {
    if (job.logoKey) {
        return `${settings.imagesUrl}/${job.tenant}.${job.logoKey}`;
    } else if (jobList?.logoKey) {
        return `${settings.imagesUrl}/${job.tenant}.${jobList?.logoKey}`;
    } else {
        return `${settings.imagesUrl}/${jobList?.id}.logo`;
    }
};

export const getHeaderUrl = (jobList: JobList, job: Job, settings: GeneralSettings) => {
    if (job.headerKey) {
        return `${settings.imagesUrl}/${job.tenant}.${job.headerKey}`;
    } else if (jobList?.headerKey) {
        return `${settings.imagesUrl}/${job.tenant}.${jobList?.headerKey}`;
    } else {
        return undefined;
    }
}

export const getFont = (jobList: JobList, job: Job) => {
    let fontFamily: string | undefined = undefined;
    if (job?.fontAsBase64) {
        let { fontKey, fontAsBase64 } = job;
        fontFamily = addFont(fontKey, fontAsBase64);
    }

    if (!fontFamily) {
        if (jobList?.fontAsBase64) {
            let { fontKey, fontAsBase64 } = jobList;
            fontFamily = addFont(fontKey, fontAsBase64);
        }
    }

    if (fontFamily) return fontFamily;

    return jobList?.fontFamily;
};

export const getColors = (jobList: JobList, job: Job) => {
    if (job.colors) return job.colors;
    return jobList.colors;
};

export const addCss = (fileName: string) => {
    var myLinks = document.querySelectorAll(`link[href="${fileName}"]`);
    if (myLinks.length > 0) return;

    const head = document.head;
    const link = document.createElement("link");

    link.type = "text/css";
    link.rel = "stylesheet";
    link.href = fileName;

    head.appendChild(link);
};
